module.exports = __webpack_public_path__ + "img/face100.984d90b0.gif";